export default "/images/vendor/flag-icons/flags/1x1/st.svg?12bfd6538546c02f033757cb90cfd472";